// extracted by mini-css-extract-plugin
export var centered = "_e-6";
export var flexible = "_e-5";
export var footer = "_e-k";
export var footerBorder = "_e-l";
export var header = "_e-c";
export var headerBorder = "_e-d";
export var headerDefault = "_e-g";
export var headerMedium = "_e-h";
export var headerPadding = "_e-e";
export var iconAndTitle = "_e-f";
export var large = "_e-4";
export var largePadding = "_e-a";
export var medium = "_e-3";
export var mediumPadding = "_e-9";
export var modal = "_e-0";
export var modalContainer = "_e-b";
export var noPadding = "_e-7";
export var skinny = "_e-1";
export var small = "_e-2";
export var smallPadding = "_e-8";
export var subtitle = "_e-j";
export var title = "_e-i";